import Lottie from 'lottie-react';
import loaderAnimation from './circular-loader.json';
import './style.scss';

export const AcCircularLoader: React.FC<{ text?: string }> = ({ text }) => (
  <div className={'ac-circular-loader'}>
    <Lottie
      className={'ac-circular-loader__animation'}
      animationData={loaderAnimation}
    />
    {text && <span>{text}</span>}
  </div>
);
